import '../../../polyfills'
import WebpackerReact from 'webpacker-react'

import { MembershipCheckoutForm } from '../../../Checkout/MembershipCheckoutForm'
import { ThreeYearCheckout } from '../../../ThreeYearCheckout'
import { TwoYearCheckout } from '../../../TwoYearCheckout'

WebpackerReact.setup({
  MembershipCheckoutForm,
  ThreeYearCheckout,
  TwoYearCheckout,
})
